export var ServiceListSubjects;
(function (ServiceListSubjects) {
    ServiceListSubjects["ServiceListPage"] = "service-list-page";
    ServiceListSubjects["ServiceListTable"] = "service-list-table";
    ServiceListSubjects["ServiceOverviewPage"] = "service-overview-page";
    ServiceListSubjects["OperationOverviewPage"] = "operation-overview-page";
    ServiceListSubjects["FeatureEmptyState"] = "feature-empty-state";
    ServiceListSubjects["CheckMapView"] = "check-map-view";
    ServiceListSubjects["CheckTableView"] = "check-table-view";
    ServiceListSubjects["SwitchViewMode"] = "switch-view-mode";
    ServiceListSubjects["TechnologyIndicator"] = "technology-indicator";
})(ServiceListSubjects || (ServiceListSubjects = {}));
//# sourceMappingURL=service-list.enum.js.map